<template>
  <div class="container">
    <template v-if="!channelType">
      <div class="first">
        <img class="img-1" src="./images/16.png" alt="" />
        <!-- 头部 -->
        <div class="center">
          <div class="header">
            <div class="left">
              <ul>
                <li style="margin: 6px 68px 0 0;">
                  <img
                    style="height: 20px;"
                    src="./images/logo1.png"
                    alt=""
                  />
                </li>
                <li
                  style="margin-right: 30px;font-weight: 600px;font-size: 14px;"
                >
                  <div>资<span style="display:inline-block;;border-bottom: 3px solid #FFFFFF;line-height: 30px;">产管</span>理
                  </div>
                </li>
                <li
                    style="margin-right: 30px;font-weight: 600px;font-size: 14px;"
                    @click="goChannel(1)"
                >
                <span
                    style="color: #fff;font-size: 14px;cursor: pointer"
                >钉钉版</span>
                </li>
                <li @click="goChannel(2)">
                  <span
                      style="color: #fff;font-size: 14px;cursor: pointer"
                  >企业微信版</span>
                </li>
                <li>
                  <span
                    @click="handleClickContact"
                    style="color: #fff;font-size: 14px;cursor: pointer"
                    >联系我们</span>
                </li>
              </ul>
            </div>
            <div class="right">
              <ul>
                 <li>
                  <a
                    href="https://yzc.niimbot.com/#/login?type=2&ch=7171&ag=1693"
                    style="font-size:14px;color: #5a8dff;background: #fff;ont-size:14px;font-weight:600;background: #FFFFFF;padding: 5px 17px;border-radius: 18px;color: #2878FF;"
                    target="_blank"
                    >免费试用</a
                  >
                </li>
                <li>
                  <!-- <a
                    href="https://jingchenyun.com/#/login"
                    target="_blank"
                    id="login"
                    style="font-size:14px;font-weight:600;border-radius: 18px;border: 1px solid #FFFFFF;padding: 5px 22px;color: #fff;"
                    >登录</a
                  > -->
                  <a href="https://yzc.niimbot.com/#/login?type=1&ch=7171&ag=1693"
                    target="_blank"
                    id="login"
                    style="font-size:14px;font-weight:600;border-radius: 18px;border: 1px solid #FFFFFF;padding: 5px 22px;color: #fff;"
                    >登录</a
                  >
                </li>
                <li style="margin-right:20px; font-size: 16px;">
                  <span style="font-size:15px;font-weight:600"
                    >电话咨询：13437104930</span
                  >
                </li>
              </ul>
            </div>
          </div>
          <div
            style="position: relative;min-width: 1600px;height: 900px;overflow:hidden;margin: 0 atuo;"
          >
            <img class="first-img" src="./images/banner.png" />
            <div class="first-div">
              <div style="font-weight: 600;font-size: 36px;margin-bottom: 12px;">
                固定资产管理，用精臣更简单
              </div>
              <div
                style="width: 43px;border: 4px solid #FFFFFF;opacity: 0.59;margin-bottom:45px;"
              ></div>
              <div class="title1">按需付费</div>
              <div class="title2">不花一分冤枉钱</div>
              <div class="title1">盘点高效</div>
              <div class="title2">10分钟盘1000条资产</div>
              <div style="margin-top:53px;">
                <a
                  class="first-a"
                  href="https://yzc.niimbot.com/#/login?type=2&ch=7171&ag=1693"
                  target="_blank"
                  >免费试用</a
                >
              </div>
            </div>
          </div>
          <div></div>
        </div>
      </div>
      <div class="first-channel">
        <div class="first-channel-item" @click="goChannel(1)">
          <h3>
            在钉钉上<br />
            使用精臣云资产
          </h3>
          <img src="./images/channel/dingtalk.png" alt="" />
        </div>
        <div class="first-channel-item" @click="goChannel(2)">
          <h3>
            在企业微信上<br />
            使用精臣云资产
          </h3>
          <img src="./images/channel/wechat.png" alt="" />
        </div>
        <div class="first-channel-item" @click="handleCounselling">
          <h3>
            在飞书上<br />
            使用精臣云资产
          </h3>
          <img src="./images/channel/fei.png" alt="" />
        </div>
      </div>
      <div class="second">
        <div style="height: 90px;">
          <h3 :class="showImg1 ? 'fannao fannao-down' : 'fannao fannao-up'">
            资产混乱?
          </h3>
          <h3 :class="showImg1 ? 'jiejue jiejue-down' : 'jiejue jiejue-up'">
            云资产·资产化乱为治
          </h3>
        </div>
        <div
          style="position: relative;height: 640px;margin-top: 20px;overflow: hidden;"
        >
          <img class="img-1" src="./images/big-1.png" alt="" />
          <img
            :class="showImg1 ? 'img-1 img-2 down' : 'img-1 img-2 up'"
            src="./images/1.png"
            alt=""
          />
        </div>

        <div style="height: 200px;background: #FAFAFA;position:relative;">
          <div
            :class="
              showImg1 ? 'center1 showCenter-down' : 'center1 showCenter-up'
            "
          >
            <ul>
              <li>
                <img src="./images/icon/1-1.png" alt="" />
                <p>摆脱excel，</p>
                <p>规范管理，不惧审查</p>
              </li>
              <li>
                <img src="./images/icon/1-2.png" alt="" />
                <p>台账清晰，记录完整</p>
              </li>
              <li>
                <img src="./images/icon/1-3.png" alt="" />
                <p>报表一目了然</p>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="third">
        <div
          style="height: 172px;background: #FAFAFA;padding-top: 62px;box-sizing: border-box;"
        >
          <h3 :class="showImg2 ? 'fannao fannao-down' : 'fannao fannao-up'">
            盘点累?
          </h3>
          <h3 :class="showImg2 ? 'jiejue jiejue-down' : 'jiejue jiejue-up'">
            云资产·盘点快又准
          </h3>
        </div>
        <div style="position: relative;height: 640px;overflow: hidden;">
          <img class="img-1" src="./images/big-2.png" alt="" />
          <img
            :class="showImg2 ? 'img-1 img-2 down' : 'img-1 img-2 up'"
            src="./images/2.png"
            alt=""
          />
        </div>

        <div style="height: 200px;background: #FAFAFA;position:relative;">
          <div
            :class="
              showImg2 ? 'center1 showCenter-down' : 'center1 showCenter-up'
            "
          >
            <ul>
              <li>
                <img src="./images/icon/2-1.png" alt="" />
                <p>10分钟盘点1000</p>
                <p>条资产</p>
              </li>
              <li>
                <img src="./images/icon/2-2.png" alt="" />
                <p>全员盘点，汇总即可,</p>
                <p>累？不存在</p>
              </li>
              <li>
                <img src="./images/icon/2-3.png" alt="" />
                <p>RFID、手机都能盘,</p>
                <p>自动生成报告</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="four">
        <div
          style="height: 172px;background: #FAFAFA;padding-top: 62px;box-sizing: border-box;"
        >
          <h3 :class="showImg3 ? 'fannao fannao-down' : 'fannao fannao-up'">
            新系统启用难?
          </h3>
          <h3 :class="showImg3 ? 'jiejue jiejue-down' : 'jiejue jiejue-up'">
            云资产·系统简单易用
          </h3>
        </div>
        <div style="position: relative;height: 640px;overflow: hidden;">
          <img class="img-1" src="./images/big-3.png" alt="" />
          <img
            :class="showImg3 ? 'img-1 img-2 down' : 'img-1 img-2 up'"
            src="./images/3.png"
            alt=""
          />
        </div>

        <div style="height: 372px;background: #FAFAFA;position:relative;">
          <div
            :class="
              showImg3 ? 'center1 showCenter-down' : 'center1 showCenter-up'
            "
          >
            <ul>
              <li>
                <img src="./images/icon/3-1.png" alt="" />
                <p>Excel一键批量</p>
                <p>导入资产</p>
              </li>
              <li>
                <img src="./images/icon/3-2.png" alt="" />
                <p>全员自助上报</p>
              </li>
              <li>
                <img src="./images/icon/3-3.png" alt="" />
                <p>手持式标签机,</p>
                <p>随打随贴</p>
              </li>
            </ul>
          </div>
          <div class="xianzhuang">
            <div class="center">
              <ul class="big-ul">
                <li>
                  <img src="./images/xianzhuang/1.png" alt="" />
                  <h3>账实不符？</h3>
                  <p>使用云资产后</p>
                  <ul>
                    <li>
                      <img
                        src="./images/xianzhuang/gou.png"
                      />财务卡片和资产账相符
                    </li>
                    <li>
                      <img
                        src="./images/xianzhuang/gou.png"
                      />简单快速补齐账物差异
                    </li>
                  </ul>
                </li>
                <li>
                  <img src="./images/xianzhuang/2.png" alt="" />
                  <h3>系统无对接？</h3>
                  <p>使用云资产后</p>
                  <ul>
                    <li>
                      <img
                        src="./images/xianzhuang/gou.png"
                      />30分钟对接钉钉、企业微信
                    </li>
                    <li>
                      <img
                        src="./images/xianzhuang/gou.png"
                      />快速和OA、采购系统打通
                    </li>
                  </ul>
                </li>
                <li>
                  <img src="./images/xianzhuang/3.png" alt="" />
                  <h3>审批不好用？</h3>
                  <p>使用云资产后</p>
                  <ul>
                    <li>
                      <img src="./images/xianzhuang/gou.png" />10分钟自定义审批流
                    </li>
                    <li>
                      <img src="./images/xianzhuang/gou.png" />或签、会签全满足
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div style="min-width:1200px;">
        <h3 style="margin: 500px 0 12px;"><img src="./images/s1.png" /></h3>
        <p><img src="./images/s2.png" /></p>
      </div>

      <div class="services">
        <div class="center">
          <ul class="big-ul">
            <li>
              <img src="./images/icon/yun.png" alt="" />
              <h3>SAAS</h3>
              <ul>
                <li>
                  <img src="./images/gou.png" />按年付费，单价低，采购风险小
                </li>
                <li><img src="./images/gou.png" />持续享受产品的体验优化</li>
                <li><img src="./images/gou.png" />持续的一对一服务</li>
              </ul>
            </li>
            <li style="margin-top: -20px;">
              <img src="./images/icon/dingwei.png" alt="" />
              <h3>私有部署</h3>
              <ul>
                <li><img src="./images/gou.png" />一次性买断，可轻量定制</li>
                <li>
                  <img src="./images/gou.png" />适合部队、政府机构等无外网环境
                </li>
                <li><img src="./images/gou.png" />数据隔离，服务器自行维护</li>
              </ul>
            </li>
          </ul>
          <div>
            <a
              href="javascript:;"
              style="cursor: pointer;font-weight: 600;font-size: 18px;color: #2878FF;background: #fff;padding: 14px 35px;border-radius: 32px;"
              class="ContactCustomerButton"
              @click="handleCounselling"
              >立即咨询</a
            >
          </div>
        </div>
      </div>
      <div class="products">
        <div class="center">
          <h3 style="margin: 200px 0 12px;"><img src="./images/p1.png" /></h3>
          <p><img src="./images/p2.png" /></p>
          <ul>
            <li class="line1">
              <h3 class="h1">固资管理系统</h3>
              <img src="./images/5.png" alt="" style="width: 407px" />
            </li>
            <li class="line1" style="margin-right:0">
              <h3>标签打印机</h3>
              <img src="./images/7.png" alt="" style="width: 285px" />
            </li>
            <li class="line2">
              <h3>标签纸</h3>
              <img src="./images/9.png" alt="" />
            </li>
            <li class="line2">
              <h3>PDA</h3>
              <img src="./images/10.png" alt="" />
            </li>
            <li class="line2" style="margin-right:0">
              <h3>扫码枪</h3>
              <img src="./images/8.png" alt="" />
            </li>
          </ul>
        </div>
      </div>
      <div class="why-choosing">
        <div class="center">
          <h3 style="padding-top: 100px">
            <img src="./images/why/3.png" alt="" />
          </h3>
          <p style="margin: 12px 0 22px 0;">
            <img src="./images/why/4.png" alt="" />
          </p>
          <a
                  href="https://yzc.niimbot.com/#/login?type=2&ch=7171&ag=1693"
                  target="_blank"
                  >
          <div class="quan">
            <div class="image1">
              <img src="./images/why/2.png" alt="" />
            </div>
            <div class="image2">
              <div style="margin-bottom: 10px;">
                <img src="./images/why/5.png" alt="" />
              </div>
              <div>
                <img src="./images/why/6.png" alt=""
                />
              </div>
            </div>
          </div>
          </a>
          <ul class="why-ul">
            <li class="li1"><img src="./images/why/1a.png" alt="" /></li>
            <li class="li2"><img src="./images/why/2a.png" alt="" /></li>
            <li class="li2"><img src="./images/why/3a.png" alt="" /></li>
            <li class="li1"><img src="./images/why/4a.png" alt="" /></li>
          </ul>
        </div>
      </div>
      <div class="five">
        <div class="center">
          <h3 style="margin-top: 200px">
            <img src="./images/cooperate/text1.png" alt="" />
          </h3>
          <p style="margin: 12px 0 85px 0">
            <img src="./images/cooperate/text2.png" alt="" />
          </p>
          <ul>
            <li><img src="./images/cooperate/1.png" /></li>
            <li><img src="./images/cooperate/2.png" /></li>
            <li><img src="./images/cooperate/3.png" /></li>
            <li><img src="./images/cooperate/4.png" /></li>
            <li><img src="./images/cooperate/5.png" /></li>
            <li><img src="./images/cooperate/6.png" /></li>
            <li><img src="./images/cooperate/7.png" /></li>
            <li><img src="./images/cooperate/8.png" /></li>
            <li><img src="./images/cooperate/9.png" /></li>
            <li><img src="./images/cooperate/10.png" /></li>
            <li><img src="./images/cooperate/11.png" /></li>
            <li><img src="./images/cooperate/12.png" /></li>
            <li><img src="./images/cooperate/13.png" /></li>
            <li><img src="./images/cooperate/14.png" /></li>
            <li><img src="./images/cooperate/15.png" /></li>
            <li><img src="./images/cooperate/16.png" /></li>
          </ul>
        </div>
      </div>
      <div class="six">
        <div class="center">
          <ul>
            <li>
              <img src="./images/bottom/huhang.png" alt="" />
              <h3>阿里云护航</h3>
              <span>顶级云服务商</span>
            </li>
            <li>
              <img src="./images/bottom/anquan.png" alt="" />
              <h3>信息安全</h3>
              <span>操作日志可追溯</span>
            </li>
            <li>
              <img src="./images/bottom/beifen.png" alt="" />
              <h3>数据备份</h3>
              <span>所有数据自动备份</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="with-us-container">
        <div class="title-content">
          <h2 class="text">关于我们</h2>
          <span class="us-text">With Us</span>
        </div>
        <div class="desc-content">
          <p>
            武汉精臣智慧标识科技有限公司，是国内便携式标签打印机创新品牌和实物管理解决方案服务商。
          </p>
          <p>
            精臣以创新践行“更简单”的品牌定位，始终深耕智能标签打印行业，在物品标签还处在繁琐的PC打印时代，便创造性地从智能便携角度出发，顺应移动互联时代趋势，推出了引领行业的智能便携标签打印产品，将标签打印简单化、便携化，推动了整个行业向移动智能转型，获得“国家高新技术企业”、“瞪羚企业”、“科技小巨人”企业等荣誉。
          </p>
          <p>
            精臣每年以10%的营收投入产品研发，现已形成了以智能硬件、精臣打印云服务平台及企业效能管理系统为核心的三大产品体系，致力于为用户提供从“物品标识”到“物品数据全生命周期管理”的一站式服务，业务覆盖商业零售、办公生活、通信电力、政企教育、金融医疗等领域，累计服务用户200万+，产品连续三年网销量位居行业前列，深受各行业用户认可。
          </p>
          <p>
            物的管理效益源自不断创新，我们坚信未来将因精臣变得更加有序而美好。
          </p>
        </div>
      </div>
      <div class="contact-us-container">
        <div class="title-content">
          <h2 class="text">联系我们</h2>
          <span class="us-text">Contact Us</span>
        </div>
        <ul class="contact-content">
          <li class="contact-content__item">
            <span class="title">电话热线</span>
            <span class="content">精臣云资产：13437104930</span>
          </li>
          <li class="contact-content__item" style="cursor: pointer" @click="handleOpenKf">
            <span class="title">在线客服</span>
            <span class="content">点击与客服在线沟通联系</span>
            <span class="time">周一至周五9:00 - 18:00</span>
          </li>
          <li class="contact-content__item">
            <span class="title">联系邮箱</span>
            <span class="content">huangpeng@niimbot.com</span>
          </li>
        </ul>
        <ul class="company-info-content">
          <li class="company-info-content__item">
            <span class="title">公司名称</span>
            <span class="desc">武汉精臣智慧标识科技有限公司</span>
          </li>
          <li class="company-info-content__item">
            <span class="title">公司地址</span>
            <span class="desc">湖北省武汉市洪山区野芷湖西路创意天地05创意工坊</span>
          </li>
        </ul>
      </div>
    </template>
    <template v-else>
      <channel :type="channelType" @channelChange="goChannel" />
    </template>
    <div class="seven">
      <div class="center">
        <div class="left" style="font-size: 14px;">
          <span
            type="text"
            style="cursor: pointer;"
            @click="userAgreementVisible = true"
            >用户许可协议</span
          >
          <span style="display: inline-block; padding: 0 10px;">|</span>
          <span
            type="text"
            style="cursor: pointer;"
            @click="privacyVisible = true"
            >隐私保护政策</span
          >
        </div>
        <div class="right" style="float: right;font-size:14px;color: #999;">
          武汉精臣智慧标识科技有限公司·所有版权©2000-2046 |
          <a href="https://beian.miit.gov.cn/" target="_blank"
            >鄂ICP备18015935号-8</a
          >
        </div>
      </div>
    </div>
    <div class="ContactCustomer">
      <ul>
<!--        <li>-->
<!--          <a-->
<!--            href="javascript:;"-->
<!--            class="ContactCustomerButton"-->
<!--            @click="handleClickOpen"-->
<!--          >-->
<!--            <img src="./images/icon/kefu.png" alt="在线咨询" />-->
<!--            <p>在线咨询</p>-->
<!--          </a>-->
<!--        </li>-->
        <li>
          <a href="javascript:;" @click="showTel" v-outside="closeTel">
            <div class="onlineConsultation" v-show="isShowTel">
              <span>
                <img src="./images/icon/dianhua.png" alt="电话咨询" />
                <p>电话咨询</p>
              </span>
              <i>13437104930</i>
            </div>
            <div v-show="!isShowTel" id="telNum">
              <img src="./images/icon/dianhua.png" alt="电话咨询" />
              <p>电话咨询</p>
            </div>
          </a>
        </li>
        <li @click="goIndex" v-show="showToTop">
          <a href="javascript:;">
            <img src="./images/icon/top.png" alt="返回顶部" />
            <p>返回顶部</p>
          </a>
        </li>
      </ul>
    </div>
    <jc-dialog
      title="用户许可协议"
      :visible.sync="userAgreementVisible"
      v-if="userAgreementVisible"
      height="75vh"
      :show-footer="false"
    >
      <UserAgreement></UserAgreement>
    </jc-dialog>
    <jc-dialog
      title="隐私保护政策"
      :visible.sync="privacyVisible"
      v-if="privacyVisible"
      height="75vh"
      :show-footer="false"
    >
      <privacy></privacy>
    </jc-dialog>
  </div>
</template>
<script>
/* eslint-disable */
import UserAgreement from "./user-agreement"
import Privacy from "./privacy"
import Channel from "./channel"
import JcDialog from "./dialog/jc-dialog"
import '../common/css/main.css'
export default {
  name: 'HelloWorld',
  components: {
    JcDialog,
    UserAgreement,
    Privacy,
    Channel
  },
  data () {
    return {
      showImg1: false,
      showImg2: false,
      showImg3: false,
      i: 0,
      up: false,
      down: false,
      showToTop: false,
      showBottom: false,
      lianxi: "",
      isShowTel: false,
      userAgreementVisible: false,
      privacyVisible: false,
      channelType: null
    };
  },
  mounted () {
    window.addEventListener('scroll', this.scrollToTop)
  },
  destroyed () {
    window.removeEventListener('scroll', this.scrollToTop)
  },
  methods: {
    scrollToTop () {
      // 滚动条距离页面顶部的距离
      // 以下写法原生兼容
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      var scroll = scrollTop - this.i
      this.i = scrollTop;
      if (scroll < -10) {
        this.up = true
        this.down = false
      } else if (scroll > 10) {
        this.up = false
        this.down = true
      }
      if (scrollTop > 800 && scrollTop < 1600) {
        if (this.down) {
          this.showImg1 = true
        } else {
          this.showImg1 = false
        }
      }
      if (scrollTop > 1800 && scrollTop < 2600) {
        if (this.down) {
          this.showImg2 = true
        } else {
          this.showImg2 = false
        }
      }
      if (scrollTop > 2800) {
        if (this.down) {
          this.showImg3 = true
        } else {
          this.showImg3 = false
        }
      }
      if (scrollTop > 68) {
        this.showBottom = true
      } else {
        this.showBottom = false
      }
      if (scrollTop > 1843) {
        this.showToTop = true
      } else {
        this.showToTop = false
      }
    },
    submit () {
    },
    showTel () {
      this.isShowTel = true
    },
    goIndex () {
      const that = this
      let ispeed = Math.floor(-that.scrollTop / 5)
      document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
    },
    handleClickContact () {
      document.documentElement.scrollTop = document.body.scrollHeight
    },
    closeTel () {
      this.isShowTel = false
    },
    // 在线客服
    handleOpenKf() {
      window.open(
      'https://affim.baidu.com/cps/chat?siteId=17955897&userId=39714517&siteToken=a0d1a4ad1ec782711ec76fb358005a0f',
          "newwindow",
      "height=800, width=800, top=10, left=10, toolbar=no, menubar=no, scrollbars=no, resizable=no, toolbar=no, location=no, status=no"
      )
    },
    // 渠道
    goChannel(type) {
      this.channelType = type
      this.goIndex()
    },
    handleCounselling() {
      const url = 'https://affim.baidu.com/unique_39714517/chat?siteId=17955897&userId=39714517&siteToken=a0d1a4ad1ec782711ec76fb358005a0f'
      window.open(url, '_blank')
    }
  }
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
.with-us-container {
  width: 1200px;
  padding 30px 0
  margin auto
  color: #000000
  .title-content {
    margin-bottom 20px
    .us-text {
      font-size: 16px
      color #999999;
    }
  }
  .desc-content {
    padding 30px
    background-color #fafafa
    p {
      margin-bottom 20px
      text-align left
      &:last-child {
        margin-bottom 0
      }
    }
  }
}
.contact-us-container {
  width: 1200px;
  margin: 0 auto;
  padding: 30px 0;
  color: #000000;
  .title-content {
    margin-bottom 20px
    .us-text {
      font-size: 16px
      color #999999;
    }
  }
  .contact-content {
    display flex
    margin-bottom 20px
    .contact-content__item {
      flex: 1
      display flex
      flex-direction: column
      align-items start
      padding 35px
      margin-right 20px
      background-color #fafafa
      color #000000
      box-sizing border-box
      .title {
        margin-bottom 5px
        font-size: 20px
        font-weight bold
      }
      .content {
        font-size: 20px
      }
      .time {
        font-size 14px
        color #999999
      }
      &:last-child {
        margin-right: 0
      }
    }
  }
  .company-info-content {
    padding 30px
    display flex
    flex-direction column
    align-items start
    background-color #fafafa
    &__item {
      display flex
      flex-direction column
      align-items start
      margin-bottom 20px
      .title {
        margin-bottom 10px
        font-size 20px
        font-weight bold
      }
      .desc {
        color #999999
      }
    }
  }
}
.form-container__error {
  position: absolute;
  left: 50%;
  top: -50%;
  transform: translate(-50%, -50%);
  // background: #000;
  padding: 10px 20px;
  opacity: 0.8;
  border-radius: 10px;
}

.img-2 {
  position: absolute;
  left: 0;
}

.down {
  -webkit-animation: top0 1s cubic-bezier(0, -0.01, 0, 0.97);
  animation-fill-mode: forwards;
}

.up {
  -webkit-animation: top670 1s cubic-bezier(0, -0.01, 0, 0.97);
  animation-fill-mode: forwards;
}

.first-div {
  position: absolute;
  left: 0;
  top: 120px;
  text-align: left;

  .title1 {
    font-weight: 600;
    font-size: 20px;
    color: #FFFFFF;
    opacity: 0.49;
    margin-top: 27px;
  }

  .title2 {
    font-weight: 600;
    font-size: 28px;
    color: #FFFFFF;
    opacity: 0.84;
  }

  .first-a {
    display: inline-block;
    background: #FFFFFF;
    border-radius: 32px;
    color: #2878FF;
    padding: 14px 35px;
    font-weight: 600;
    font-size: 18px;
  }
}

.bottom {
  box-sizing: border-box;
  width: 100%;
  height: 68px;
  background: #333;
  position: fixed;
  left: 0px;
  bottom: 0px;

  i {
    position: absolute;
    right: -680px;
    bottom: 12px;
    font-weight: 600;
    font-size: 22px;
  }

  .input {
    box-sizing: border-box;
    width: 502px;
    height: 50px;
    background: #FFFFFF;
    border-radius: 25px;
    padding: 10px 24px;
    border: none;
    // float left
  }

  .left {
    width: 500px;
    margin-top: 10px;
    position: relative;
  }

  a {
    position: absolute;
    width: 140px;
    height: 50px;
    line-height: 50px;
    font-weight: 600;
    font-size: 18px;
    color: #fff;
    right: -180px;
    bottom: 0;
    background: #2878FF;
    border-radius: 32px;
  }

  button {
    cursor: pointer;
    display: inline-block;
    position: absolute;
    color: #2878FF;
    width: 100px;
    height: 50px;
    line-height: 50px;
    font-weight: 600;
    font-size: 17px;
    right: 0;
    top: 0px;
    background: #EBF2FE;
    border-radius: 0px 25px 25px 0px;
    border: none;
  }
}

.fannao {
  font-family: PingFang SC;
  font-style: normal;
  text-align: center;
  font-size: 38px;
  color: #262626;
  line-height: 90px;
}

.fannao-down {
  -webkit-animation: fannao-down 1s cubic-bezier(0, -0.01, 0, 0.97);
  animation-fill-mode: forwards;
}

.fannao-up {
  -webkit-animation: fannao-up 1s cubic-bezier(0, -0.01, 0, 0.97);
  animation-fill-mode: forwards;
}

.jiejue {
  color: #262626;
  font-size: 38px;
}

.jiejue-down {
  -webkit-animation: jiejue-down 1s cubic-bezier(0, -0.01, 0, 0.97);
  animation-fill-mode: forwards;
}

.jiejue-up {
  -webkit-animation: jiejue-up 1s cubic-bezier(0, -0.01, 0, 0.97);
  animation-fill-mode: forwards;
}

.center1 {
  color: #000;
  font-size: 22px;
  width: 1060px;
  height: 200px;
  background: rgba(255, 255, 255, 0.8);
  box-shadow: 0px 4px 170px rgba(0, 0, 0, 0.07);
  backdrop-filter: blur(15px);
  border-radius: 30px;
  margin: 0 auto;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);

  ul {
    width: 900px;
    margin: 0 auto;
    display: flex;
    flex: 1;
    flex-wrap: wrap;

    li {
      margin-top: 30px;
      flex-direction: column;
      width: 33.33%;
    }
  }
}

.showCenter-down {
  -webkit-animation: showCenter-down 1s cubic-bezier(0, -0.01, 0, 0.97);
  animation-fill-mode: forwards;
}

.showCenter-up {
  -webkit-animation: showCenter-up 1s cubic-bezier(0, -0.01, 0, 0.97);
  animation-fill-mode: forwards;
}

.seven {
  height: 100px;
  line-height: 100px;
  color: #595959;
  // margin-bottom: 68px;

  .left {
    float: left;
  }
}

.services {
  background: url('./images/12.png');
  height: 540px;
  margin-top: 80px;

  .big-ul {
    width: 950px;
    display: flex;
    // flex 1;
    flex-wrap: wrap;
    margin: 0 auto 20px;

    > li {
      box-sizing: border-box;
      width: 340px;
      height: 440px;
      margin-right: 270px;
      text-align: left;

      > img {
        margin-top: 90px;
      }

      h3 {
        font-weight: 600;
        font-size: 32px;
        color: #fff;
        margin: 12px 0 30px 0;
      }

      ul {
        margin-top: 50px;

        li {
          margin-top: 20px;
          font-weight: 500;
          font-size: 20px;
          color: #fff;

          img {
            vertical-align: text-bottom;
            margin-right: 10px;
          }
        }
      }
    }

    > li:last-child {
      margin-right: 0;
    }
  }
}

.xianzhuang {
  color: #000;
  position: absolute;
  bottom: -480px;
  left: 50%;
  transform: translateX(-50%);

  // margin-top -260px
  .big-ul {
    display: flex;
    flex: 1;
    flex-wrap: wrap;
    margin: 100px 0 200px 0;

    > li {
      box-sizing: border-box;
      width: 380px;
      height: 440px;
      margin-right: 30px;
      background: #FFFFFF;
      box-shadow: 0px 17.8819px 95.668px rgba(0, 0, 0, 0.06);
      border-radius: 22px;
      text-align: left;
      padding: 57px 50px;

      h3 {
        font-weight: 600;
        font-size: 26px;
        color: #262626;
        margin: 26px 0 12px 0;
      }

      p {
        font-size: 14px;
        color: #999;
      }

      ul {
        margin-top: 80px;

        li {
          margin-top: 12px;
          font-size: 20px;
          color: #404040;

          img {
            vertical-align: text-bottom;
            margin-right: 10px;
          }
        }
      }
    }

    > li:last-child {
      margin-right: 0;
    }
  }
}

.products {
  ul {
    h3 {
      padding: 30px 30px 60px;
      font-size: 18px;
      font-weight: 600;
    }

    .line1 {
      height: 454px;
      width: 584px;

      img {
        margin: 0 auto;
      }
    }

    .h1 {
      padding: 30px 30px 78px;
    }

    .line2 {
      height: 400px;
      width: 380px;

      img {
        width: 186px;
        margin: 0 auto;
      }
    }

    width: 1200px;
    display: flex;
    flex: 1;
    flex-wrap: wrap;
    margin: 100px 0 200px 0;

    li {
      background: #FFFFFF;
      box-shadow: 0px 17.8819px 95.668px rgba(0, 0, 0, 0.06);
      border-radius: 22px;
      margin: 30px 30px 0 0;
      display: flex;
      // align-items: center;
      flex-direction: column;
      width: 50%;
    }

    h3 {
      color: #000000;
      display: flex;
    }
  }
}

.why-choosing {
  background: #FAFAFA;
  box-sizing: border-box;

  .quan {
    width: 481px;
    height: 481px;
    margin: 0 auto;
    background: url('./images/why/1.png');
    position: relative;
    cursor: pointer;
    .image1, .image2 {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  ul {
    width: 1200px;
    height: 600px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-top: -520px;
  }
}
</style>
<style scoped>
.container {
  font-family: PingFang SC;
  width: 100%;
  height: 100%;
  color: #fff;
  overflow: hidden;
  box-sizing: border-box;
}
.container .img-1 {
  height: 640px;
  position: absolute;
  left: 50%;
  width: 1920px;
  margin-left: -960px;
}
.center {
  width: 1200px;
  margin: 0 auto;
}
.first {
  /* background: url("./images/16.png") no-repeat; */
  height: 797px;
  position: relative;
  margin-bottom: 112px;
}
.first .first-img {
  position: absolute;
  right: 170px;
  bottom: 240px;
  width: 1059px;
}
.header {
  width: 1200px;
  height: 60px;
  line-height: 60px;
  position: absolute;
  z-index: 10;
}
.first-channel {
  display: flex;
  margin-bottom: 20px;
}
.first-channel-item {
  width: calc((100% - 30px) / 3);
  margin-right: 15px;
  cursor: pointer;
  position: relative;
}
.first-channel-item img {
  width: 100%;
}
.first-channel-item:last-of-type {
  margin-right: 0;
}
.first-channel-item h3 {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  text-align: left;
  font-size: 36px;
  padding-left: 35px;
}
.first-channel-item h3:before {
  content: "";
  position: absolute;
  top: -16px;
  left: 45px;
  width: 60px;
  height: 3px;
  background-color: #fff;
}
.leader b {
}
.left ul li {
  float: left;
  margin-right: 32px;
}
.right ul li {
  float: right;
  margin-left: 16px;
}
.five .center ul {
  width: 1260px;
  display: flex;
  flex-wrap: wrap;
  justify-content: left;
}
.five .center ul li {
  margin: 15px;
}
.five .center ul li:nth-child(4n+1) {
  margin-left: 0;
}
.six {
  background: #fafafa;
  color: #262626;
  margin-top: 200px;
}
.six span {
  color: #595959;
  font-size: 16px;
}
.six h3 {
  margin: 30px 0 7px 0;
}
.six .center ul {
  width: 1200px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.six .center ul li {
  margin: 70px 144px;
}
.seven {
  background: #f5f5f5;
}
.ContactCustomer {
  position: fixed;
  right: 0;
  bottom: 130px;
  z-index: 200;
}
.ContactCustomer li {
  width: 88px;
  height: 74px;
  background: #2878ff;
  border-radius: 12px 0px 0px 12px;
  text-align: center;
  margin-bottom: 6px;
  box-sizing: border-box;
  cursor: pointer;
  list-style: none;
}
.ContactCustomer a {
  display: block;
  padding: 10px 0;
}

.ContactCustomer p {
  font-size: 14px;
  color: #fafafa;
}

.onlineConsultation {
  text-align: center;
  position: relative;
  right: 180px;
  bottom: 10px;
  z-index: 199;
  font-size: 20px;
  font-weight: 700;
  color: #5a8dff;
  box-shadow: 0px 0px 7px 0px rgba(58, 63, 70, 0.22);
  width: 269px;
  height: 74px;
  background: #2878ff;
  border-radius: 12px 0px 0px 12px;
}
.onlineConsultation span {
  padding-top: 8px;
  display: inline-block;
  width: 88px;
  height: 74px;
  background: #2878ff;
  border-radius: 12px 0px 0px 12px;
  text-align: center;
  margin-bottom: 2px;
  box-sizing: border-box;
  position: absolute;
  left: 0;
  top: 0;
}
.onlineConsultation i {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  color: #fff;
  font-weight: 600;
  font-size: 18px;
}
.ContactCustomer li:hover {
  box-shadow: 0px 0px 7px 0px rgba(58, 63, 70, 0.22);
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue